function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.98101 6.76701C3.23868 5.94907 1.97383 5.88778 1.15589 6.63011C0.337957 7.37243 0.276665 8.63728 1.01899 9.45522L3.98101 6.76701ZM9.72689 16.0741L8.24588 17.4182C8.62497 17.8359 9.16282 18.0741 9.72689 18.0741C10.291 18.0741 10.8288 17.8359 11.2079 17.4182L9.72689 16.0741ZM23.981 3.34411C24.7233 2.52617 24.662 1.26132 23.8441 0.518994C23.0262 -0.223335 21.7613 -0.162043 21.019 0.655894L23.981 3.34411ZM1.01899 9.45522L8.24588 17.4182L11.2079 14.73L3.98101 6.76701L1.01899 9.45522ZM11.2079 17.4182L23.981 3.34411L21.019 0.655894L8.24588 14.73L11.2079 17.4182Z",
  fill: "currentcolor"
});

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 19,
    viewBox: "0 0 25 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.cf7684d5.svg";
export { ForwardRef as ReactComponent };